/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetHistoryResponse {
    getFixupPrototypeFunction() { return BudgetHistoryResponse.fixupPrototype; }

    static newInstance(model: Partial<BudgetHistoryResponse>): BudgetHistoryResponse {
        let obj = Object.assign(new BudgetHistoryResponse(), model);
        BudgetHistoryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetHistoryResponse>): BudgetHistoryResponse {
        if (!model) return null;
        return BudgetHistoryResponse.newInstance(<BudgetHistoryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetHistoryResponse) {
        if (!obj) return;

        models.BudgetHistoryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetHistoryResponse): boolean {
        Object.setPrototypeOf(obj, BudgetHistoryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.budget_history) {
            for (let val of this.budget_history) {
                models.BudgetHistoryDataModel.fixupPrototype(val);
            }
        }
    }

    /**
     * Budget History data
     */
    budget_history: Array<models.BudgetHistoryDataModel>;

}
